(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Announcement rotation */
  var ann = $('[data-announce]');
  if (ann) {
    var msgs = $$('.announce__msg', ann), i = 0;
    if (msgs.length > 1) setInterval(function () {
      msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active');
    }, 4500);
  }

  /* Cart drawer */
  function drawer() { return $('#CartDrawer'); }
  function openCart() { var d = drawer(); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeCart() { var d = drawer(); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function refreshCart() {
    return fetch('/?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = html.querySelector('#CartDrawer');
        var cur = drawer();
        if (fresh && cur) { var open = cur.classList.contains('is-open'); cur.innerHTML = fresh.innerHTML; if (open) cur.classList.add('is-open'); }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-cart-open]');
    if (open && drawer()) { e.preventDefault(); refreshCart().then(openCart); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }
    var q = t.closest('[data-qty-change]');
    if (q) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(q.getAttribute('data-qty-change'), 10), quantity: parseInt(q.getAttribute('data-qty'), 10) }) })
        .then(refreshCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* AJAX add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.js-ajax-add');
    if (!form) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn && btn.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(); })
      .then(openCart)
      .catch(function (err) { alert((err && err.description) || 'Sorry, we could not add that to your cart.'); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* Product page */
  var root = $('[data-product]');
  if (root) {
    var data = JSON.parse($('[data-product-json]', root).textContent);
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-btn]', root);
    var priceBox = $('[data-price]', root);
    var sticky = $('[data-sticky]', root);
    var stickyPrice = $('[data-sticky-price]', root);
    var stickyBtn = $('[data-sticky-btn]', root);

    function showSlide(n) {
      $$('.pdp__slide', root).forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      $$('.pdp__thumb', root).forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
    }
    $$('[data-thumb]', root).forEach(function (b) { b.addEventListener('click', function () { showSlide(parseInt(b.getAttribute('data-thumb'), 10)); }); });

    function currentOptions() {
      return $$('[data-option]', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function priceHtml(v) {
      var h = '<span class="price' + (v.compare ? ' price--sale' : '') + '">';
      if (v.compare) h += '<s class="price__compare">' + v.compare + '</s>';
      h += '<span class="price__now">' + v.price + '</span>';
      if (v.compare) h += '<span class="badge badge--sale">' + v.off + '% off</span>';
      return h + '</span>';
    }
    function onOption() {
      var opts = currentOptions();
      var v = data.variants.filter(function (x) { return x.options.join('|') === opts.join('|'); })[0];
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; if (stickyBtn) stickyBtn.disabled = true; return; }
      idInput.value = v.id;
      priceBox.innerHTML = priceHtml(v);
      if (stickyPrice) stickyPrice.textContent = v.price;
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? (addBtn.getAttribute('data-label') || 'Add to cart') : 'Sold out';
      var bn = $('[data-buy-now]', root); if (bn) bn.disabled = !v.available;
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = addBtn.textContent; }
      if (v.media) showSlide(Math.max(0, v.media - 1));
      history.replaceState(null, '', '?variant=' + v.id);
    }
    $$('[data-option] input', root).forEach(function (i) { i.addEventListener('change', onOption); });

    var qty = $('[data-qty]', root);
    if (qty) {
      var qi = $('input', qty);
      $('[data-qty-minus]', qty).addEventListener('click', function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) - 1); });
      $('[data-qty-plus]', qty).addEventListener('click', function () { qi.value = (parseInt(qi.value, 10) || 1) + 1; });
    }

    /* Sticky add-to-cart (mobile) */
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        stickyBtn.tabIndex = past ? 0 : -1;
      }).observe(addBtn);
      stickyBtn.addEventListener('click', function () { addBtn.click(); });
    }
  }

  /* Related products */
  var rel = $('[data-related]');
  if (rel && rel.getAttribute('data-url')) {
    fetch(rel.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-related]');
      if (d && d.innerHTML.trim()) rel.innerHTML = d.innerHTML;
    }).catch(function () {});
  }
})();

/* Swipe rail hint + progress dashes */
(function () {
  function init(rail) {
    var wrap = rail.parentNode, hint = wrap.querySelector('[data-rail-hint]');
    if (!hint) return;
    var dashes = hint.querySelector('[data-rail-dashes]'), count = hint.querySelector('[data-rail-count]');
    var items = rail.children, n = items.length, on = 0;
    dashes.innerHTML = ''; for (var i = 0; i < n; i++) dashes.appendChild(document.createElement('i'));
    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function upd() {
      var w = items[0] ? items[0].offsetWidth + 14 : 1;
      on = Math.min(n - 1, Math.round(rail.scrollLeft / w));
      Array.prototype.forEach.call(dashes.children, function (d, k) { d.className = k === on ? 'is-on' : ''; });
      count.textContent = 'Swipe ' + pad(on + 1) + ' / ' + pad(n) + ' →';
    }
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-rail]'), init);
})();

/* Mobile bottom button: show after the hero, hide near footer */
(function () {
  var bar = document.querySelector('[data-mbar]'), foot = document.querySelector('.im-footer,.footer');
  if (!bar) return;
  var nearFoot = false;
  function upd() { bar.classList.toggle('is-visible', window.scrollY > 500 && !nearFoot); }
  if ('IntersectionObserver' in window && foot) new IntersectionObserver(function (e) { nearFoot = e[0].isIntersecting; upd(); }).observe(foot);
  window.addEventListener('scroll', upd, { passive: true }); upd();
})();

/* Scroll reveal */
(function () {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && window.Shopify.designMode)) return;
  var sel = '.im-head,.card,.im-step,.im-faq__item,.im-trust__item,.im-stat,.im-rt__in .tb';
  var els = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function (el) { return !el.closest('.im-hero,.im-banner'); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function (el, i) {
    var sib = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
    el.style.setProperty('--d', Math.min(sib, 4) * 0.09 + 's');
    el.classList.add('will-reveal'); io.observe(el);
  });
})();

/* Overlay header turns solid after scroll */
(function () {
  var h = document.querySelector('[data-header][data-overlay]');
  if (!h) return;
  function upd() { h.classList.toggle('is-solid', window.scrollY > 40); }
  window.addEventListener('scroll', upd, { passive: true }); upd();
})();
